<div class="home-wrapper">
    <!-- The sign: the ellipse clip acts as the arch and the bulbs trim it -->
    <section class="hero-marquee">
        <div class="hero-content container">
            <h1 class="hero-title">
                ¿Qué hacer en
                <button type="button" class="city-btn" [class.is-open]="cityPickerOpen" (click)="toggleCityPicker()"
                    aria-controls="city-options" [attr.aria-expanded]="cityPickerOpen"
                    [attr.aria-label]="city?.name ? 'Cambiar de ciudad. Ahora: ' + city.name : 'Elegir ciudad'">
                    <span class="city-name">{{ city?.name || 'tu ciudad' }}?</span>
                    <i class="fal fa-angle-down city-chevron" aria-hidden="true"></i>
                </button>
            </h1>

            <!-- The cities live in the sign itself instead of an overlay. One
                 row that centres while it fits and scrolls sideways once it
                 does not, so it holds up as more cities come in. -->
            <div class="city-options" id="city-options" *ngIf="cityPickerOpen" @cityOptions
                [@.disabled]="reducedMotion">
                <div class="city-options-track">
                    <button type="button" class="city-chip" [class.is-current]="!city" (click)="pickCity(null)">
                        Todas
                    </button>
                    <button type="button" class="city-chip" *ngFor="let ciudad of ciudades"
                        [class.is-current]="city?.id === ciudad.city.id" (click)="pickCity(ciudad.city)">
                        {{ ciudad.city.name }}
                    </button>
                </div>
            </div>

            <button type="button" class="hero-cta" (click)="goToLink()">
                Ver toda la cartelera
                <i class="fal fa-long-arrow-right" aria-hidden="true"></i>
            </button>

            <!-- The marquee: the next shows on sale, running past -->
            <div class="marquee" *ngIf="marqueeShows.length">
                <div class="marquee-viewport">
                    <div class="marquee-track">
                        <ng-container *ngTemplateOutlet="marqueeRun; context: { clone: false }"></ng-container>
                        <!-- second lap, so the loop has no seam -->
                        <ng-container *ngTemplateOutlet="marqueeRun; context: { clone: true }"></ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="bulbs" aria-hidden="true">
            <span class="bulb" *ngFor="let bulb of bulbs; let i = index" [style.left.%]="bulb.left"
                [style.top]="bulb.top" [style.animation-delay]="(i * -0.21) + 's'"></span>
        </div>
    </section>
</div>

<ng-template #marqueeRun let-clone="clone">
    <div class="marquee-run" [attr.aria-hidden]="clone ? 'true' : null">
        <a class="marquee-item" *ngFor="let show of marqueeShows" [routerLink]="['/event', show.slug]"
            [attr.tabindex]="clone ? -1 : null">
            <span class="show-date">{{ show.startsAt | date:'EEE d MMM' }}</span>
            <span class="show-time">{{ show.startsAt | date:'HH:mm' }}</span>
            <span class="show-title">{{ show.title }}</span>
            <span class="show-venue" *ngIf="show.venue">{{ show.venue }}</span>
            <span class="show-price" *ngIf="show.price">desde {{ show.price }} €</span>
        </a>
    </div>
</ng-template>

<div class="sections-home">
    <!-- Solo con una ciudad elegida: sin ella el título sería un «Explorar» a
         secas y las tarjetas repetirían lo que ya trae el scroll infinito -->
    <div class="first-cards padding-home" *ngIf="city && (explorar|async)?.length > 0">
        <!-- Ya no cae encima de una foto oscura, así que el título va en tinta -->
        <app-cards sizeTitle="big" [title]="(tituloObs | async)" [titleWhite]="false"
            [events]="explorar"></app-cards>
        <div class="container" #container>
        <div class="title-cards d-flex pointer-in align-items-center title-disc" [class.color-white]="titleWhite"
            [class.pointer-in]="link" (click)="goToLink()">
            <p class="h2" style="margin-bottom: 30px;">Descubre todos los eventos</p>
            <!-- <i *ngIf="arrow" class="fal fa-long-arrow-right icon-title fa-2x"></i> -->
        </div>
    </div>
</div>

<!-- <div class="default-cards" *ngIf="(eventosCategoriasHome[0]?.events | async)?.length > 0">
        <app-cards title="{{ eventosCategoriasHome[0]?.titulo }}" [events]="eventosCategoriasHome[0]?.events" link="/category/{{eventosCategoriasHome[0]?.slug}}"></app-cards>
    </div> -->

<div class="first-cards container infinity-home">
    <app-infinity-scroll [fromHome]="true"></app-infinity-scroll>
</div>

<div class="default-cards">
    <app-circles></app-circles>
</div>

<!-- <div class="default-cards" *ngFor="let category of eventosCategoriasHome | slice:1 ; let i = index">
        <app-cards *ngIf="(category?.events | async)?.length > 0" title="{{ category?.titulo }}" [events]="category?.events" link="/category/{{category.slug}}"></app-cards>
    </div> -->

<!-- <div class="default-cards">
        <app-info-loks></app-info-loks>
    </div> -->
</div>

<!-- <div>
    <app-download-app></app-download-app>
</div> -->
<!-- 
<div class="icon-chatbot w-100">
    <div class="container-chatbot-btn pointer-in" (click)="openChatbot()">
        <img src="../assets/img/icon-chatbot-white.svg" alt="">
    </div>
</div> -->